import Vue from 'vue';
import MostViewedCategories from '@/plugins/graphql/queries/v2/most-viewed-categories.gql';
import { CategoryModel } from '@/helpers/entities/models/CategoryModel';
/**
 * Component for fetching categories sorted by number of views
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
export default Vue.extend({
    apollo: {
        mostViewedCategories: {
            query: MostViewedCategories,
            variables() {
                return {
                    appUuid: this.appUuid,
                    first: this.limit,
                };
            },
            update(data) {
                const categoryNode = data.categoriesByMiniAppViews.edges;
                return categoryNode.map((cat) => {
                    return new CategoryModel(cat.node);
                });
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        limit: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            mostViewedCategories: null,
        };
    },
    computed: {
        showLinkButton() {
            const categories = this.mostViewedCategories;
            const fiveRecords = 5;
            return !!categories && categories.length >= fiveRecords;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const vm = this;
            return this.$scopedSlots.default({
                mostViewedCategories: vm.mostViewedCategories,
                showLinkButton: vm.showLinkButton,
            });
        }
    },
});
